import { AbstractControl } from '@angular/forms';

export function ValidateControlCode(control: AbstractControl) {
    if (control.value) {
        const value = String(control.value)
        if (new Set(value).size == 3) {
          return null
        }
        return { 'controlCodeInvalid': true };
      }
    return { 'controlCodeInvalid': true };
}
